import React from "react";
import "./Clarifications.css";

let langData = require("../../../Data/language.json");
let manualIcon = require("../../../Images/Icons/manualIcon.svg");
let lowAmountIcon = require("../../../Images/Icons/lowAmount.svg");
let score3Icon = require("../../../Images/Icons/score3.svg");

export default function Clarifications(props) {
  return (
    <div className="row languageRow">
      <div className="container-fluid col-12 languageContainer">
        <p>{langData[props.language].profile.symbolTitle}</p>
        <div className="row">
          <img
            className="clarificationIcon"
            src={manualIcon}
            alt="clarificationIcon"
          />
          <p className="clarificationText">
            = {langData[props.language].profile.manuallyAdded}
          </p>
        </div>
        <div className="row">
          <img
            className="clarificationIcon"
            src={lowAmountIcon}
            alt="clarificationIcon"
          />
          <p className="clarificationText">
            = {langData[props.language].profile.lowAmount}
          </p>
        </div>
        <div className="row">
          <img
            className="clarificationIcon"
            src={score3Icon}
            alt="clarificationIcon"
          />
          <p className="clarificationText">
            = {langData[props.language].profile.climateScore}
          </p>
        </div>
      </div>
    </div>
  );
}
